import React, {useState} from 'react';

import {ProfileIcon} from '~/Components/Icons/Icons'
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";


const AdminRegistrationInvitees = ({guests, match, ...props}) => {


    if (!guests) {
        return <></>;
    }

    const invitees = guests.filter((g) => {
        return !g.main;
    });

    return (

        <div>
            <div className="row mt-4">
                <div className="col-12">
                    <h2 className="mb-3">Invitees List</h2>
                </div>
            </div>

            {invitees.map((guest, index) => (

                <div className="row" key={index}>
                    <div className="col-2">
                         <ProfileIcon color="#999BB5" classes="d-inline" /> Guest {index + 1}
                    </div>

                    <div className="col-3">
                        {guest.first_name || guest.last_name ? guest.first_name + ' ' + guest.last_name : '-'}
                    </div>

                    <div className="col-7 text-right">
                        <Link to={`${match.url}/guest/${guest.id}`} className="text-primary">View invitee profile</Link>
                    </div>
                </div>
            ))}

        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(withRouter(AdminRegistrationInvitees));
